import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "PostList A1",
  "component": "post-list"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "postlist-a1"
    }}>{`PostList A1`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ul
  sx={{
    listStyle: 'none',
    m: 0,
    px: 3,
    py: 4,
  }}>
  {posts.map((post) => (
    <li
      key={post.id}
      sx={{
        mb: 4,
      }}>
      <Themed.h2
        sx={{
          m: 0,
        }}>
        <Link
          to={post.slug}
          sx={{
            color: 'inherit',
            textDecoration: 'none',
            ':hover,:focus': {
              color: 'primary',
              textDecoration: 'underline',
            },
          }}>
          {post.title}
        </Link>
      </Themed.h2>
      <small sx={{ fontWeight: 'bold' }}>{post.date}</small>
      <Themed.p>{post.excerpt}</Themed.p>
    </li>
  ))}
</ul>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      